import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function timezoneValidator(validList: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const isValid: number = validList.findIndex(value => value == control.value);

        if (isValid != -1)
            return null;

        control.setErrors({ timezone: true });

        return { timezone: true };
    };
}